import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import AppStrings from '../config/appstring';
import { useLocation } from 'react-router-dom';



const NaviTest = ({ type, className, feeType, AdmissionID }) => {

    const location = useLocation();
    const name = location.state?.name || 'No Name Passed';

  const [feeDetails, setFeeDetails] = useState([]);
  const [totalAmt, setTotalAmt] = useState(0);
  const [Header1, setHeader1] = useState(0);
  const [Header2, setHeader2] = useState(0);
  const [Header3, setHeader3] = useState(0);
  const tableRef = useRef();
  
  // Fetch the fee details when component mounts or parameters change
  useEffect(() => {
    const fetchFeeDetails = async () => {
        const feeType = name;
        const className = 'I';
        const type = 'N';
        const AdmissionID='I16'
       

     // const url = `${AppStrings.FeesDetailGet}?TYPE=${type}&CLASS=${className}&FEESTYPE=${feeType}&ADMISSIONID=${AdmissionID}`;
     const url = ` https://school.agnisofterp.com/agni/prinit/detail?REFNO=2425SCISM360`;
      try {
        const response = await axios.get(url);
        const result = response.data.data.result || response.data.data[0].LIST;
//console.log(response.data.data[0].COMPANYDETAIL[0].DATA1,'jjjjjjjjjjj');
setTotalAmt(response.data.data[0].TOTAL);
setHeader1(response.data.data[0].COMPANYDETAIL[0].DATA1);
setHeader2(response.data.data[0].COMPANYDETAIL[0].DATA2);
//console.log(response.data.data[0].COMPANYDETAIL[0].DATA2,'ttttttttttttttt');
        if (Array.isArray(result)) {
          const withEditable = result.map(item => ({ ...item, current: '', discount: '' }));
          setFeeDetails(withEditable);
        } else {
          alert("No fee records found.");
          setFeeDetails([]); // Clear fee details if no records found
        }
      } catch (error) {
        console.error("Error fetching fee details:", error);
        alert("Failed to fetch fee details.");
      }
    };

    fetchFeeDetails();
  }, [type, className, feeType, AdmissionID]); // re-run the effect when any of these change

  // Handle print functionality
  const handlePrint = () => {
    const printContents = tableRef.current.innerHTML; // Get the table HTML
    const printWindow = window.open('', '_blank', 'width=900,height=650');

    printWindow.document.write(`
     <html>
  <head>
    <style>
      body {
        font-family: Arial, sans-serif;
        padding: 20px;
      }
      .print-container {
        border: 2px solid #000;
        padding: 20px;
        margin: auto;
      }
      .header-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
      }
      .header-box {
        width: 25%;
        height:100px;
        padding: 10px;
        box-sizing: border-box;
        border: 1px solid #ccc;
        text-align: center;
        background-color: #f9f9f9;
      }
         .Logo {
        width: 18%;
        height:100px
    }
        .Address
        {
         width: 82%;
    }
      table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 0px;
      }
      th, td {
        border: 1px solid #ccc;
        padding: 8px;
        text-align: left;
      }
      th {
        background-color: #f2f2f2;
      }
      h2 {
        text-align: center;
        margin-top: 0;
      }
      .footer {
        text-align: center;
        margin-top: 0px;
        font-size: 12px;
        color: #888;
      }
    </style>
  </head>
  <body onload="window.print(); window.close();">
    <div class="print-container">
      <div class="header-row">
        <div class="header-box Logo">Name: John Doe</div>
        <div class="header-box Address"><h3>${Header1}</h3><h3>${Header2}</h3></div>
      </div>
    
      <!-- Your table content injected from JS -->
      <div>${printContents}</div>

        <!-- Four 25% columns -->
        <br/>
      <div class="header-row">
        <div class="header-box">${totalAmt}</div>
        <div class="header-box">Class: 10</div>
        <div class="header-box">Admission No: A1234</div>
        <div class="header-box">Date: 07/05/2025</div>
      </div>

      <div class="footer">Generated by Fee System</div>
    </div>
  </body>
</html>
    `);
    printWindow.document.close();
  };

  const headerCellStyle = { padding: '10px', backgroundColor: '#f9f9f9', border: '1px solid #ccc' };
  const cellStyle = { padding: '10px', border: '1px solid #ccc' };

  return (
    <div>
      <div ref={tableRef}>
        {feeDetails.length > 0 ? (
          <table style={{ width: '100%', marginTop: '0px', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={headerCellStyle}>Fee Type</th>
                {/* <th style={headerCellStyle}>Fee Amount</th>
                <th style={headerCellStyle}>Discount</th> */}
                <th style={headerCellStyle}>Paid</th>
              </tr>
            </thead>
            <tbody>
              {feeDetails.map((fee, idx) => {
                // const feeAmount = parseFloat(fee.FEES) || 0;
                // const discount = parseFloat(fee.discount) || 0;
                // const payable = feeAmount - discount;

                return (
                  <tr key={idx}>
                    <td style={cellStyle}>{fee.TYPE}</td>
                    {/* <td style={cellStyle}>{fee.FEES}</td>
                    <td style={cellStyle}>{fee.discount}</td> */}
                    <td style={cellStyle}>{fee.PAYMENT}</td>
                    {/* <div style={{ fontSize: '0.8em', color: '#555' }}>
                      Payable: ₹{payable.toFixed(2)}
                    </div> */}
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <p>No fee data available.</p>
        )}
      </div>

      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <button onClick={handlePrint} style={{
          padding: '10px 20px',
          backgroundColor: '#007bff',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer'
        }}>
          🖨️ Print Table
        </button>
      </div>
    </div>
  );
};

export default NaviTest;
